import Task from "../Task";
import React from "react";
export default function renderTask(task, props)
                {
                  return <Task
                  {...task}
                  label={task.title}
                  checked={task.done}
                  onClick={() => props.updateTask(task.id)}
                  onClickFocus={() => props.toggleStar(task.id)}
                />
                }